import { useState } from "react"
import { useCookies } from "react-cookie"
import AlertCheckout from "./alert_checkout"

interface Props {
  checkoutModalTarget: string
  cookieName: string
  twitterMigration: boolean
  urls: object
}

const HelloCard = (props: Props) => {
  const [cookies, setCookie] = useCookies([props.cookieName])
  const [hideHelloCard, setHideHelloCard] = useState(cookies[props.cookieName])

  const disableHelloCard = () => {
    setCookie(props.cookieName, true)
    setHideHelloCard(true)
  }

  if (hideHelloCard) {
    return null
  }

  return <AlertCheckout {...props} onFinish={disableHelloCard} />
}

export default HelloCard
